/* Help configure the state-base ui.router
 Base auto-generated by hot-towel generator made by John Papa
 */
(function () {
    'use strict';

    angular.module('blocks.router').provider('routerHelper', routerHelperProvider);

    routerHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];
    /* @ngInject */
    function routerHelperProvider ($locationProvider, $stateProvider, $urlRouterProvider) {
        var config = {
            docTitle: undefined,
            resolveAlways: {},
        };

        /* to enable this we need to rewrite all requests to / or index.html in server.
         This will remove # in url for newer browsers.
         */
        $locationProvider.html5Mode(true);

        this.configure = function (cfg) {
            angular.extend(config, cfg);
        };

        this.$get = RouterHelper;
        RouterHelper.$inject = ['$location', '$state', '$log', '$transitions'];
        /* @ngInject */
        function RouterHelper ($location, $state, $log, $transitions) {
            var handlingStateChangeError = false;
            var hasOtherwise = false;
            var stateCounts = {
                errors: 0,
                changes: 0,
            };

            var service = {
                configureStates: configureStates,
                getStates: getStates,
                stateCounts: stateCounts,
            };

            init();

            return service;

            // /////////////

            function configureStates (states, otherwisePath) {
                // TODO: add a handler for multiple overlays here
                states.forEach(function (state) {
                    state.config.params = Object.assign({
                        issueOverlay: { dynamic: true },
                        issueOverlayIssueId: { dynamic: true },
                        issueOverlayIssueType: { dynamic: true },
                        issueOverlaySourceCodeId: { dynamic: true },
                        issueOverlayContentId: { dynamic: true },
                        issueOverlayPageId: { dynamic: true },
                        issueOverlayCheckId: { dynamic: true },
                    }, state.config.params);

                    state.config.resolve = angular.extend(state.config.resolve || {}, config.resolveAlways);
                    $stateProvider.state(state.state, state.config);


                });

                if (otherwisePath && !hasOtherwise) {
                    hasOtherwise = true;
                    $urlRouterProvider.otherwise(otherwisePath);
                }
            }

            function handleRoutingErrors () {
                // Route cancellation:
                // On routing error, go to login.
                // Provide an exit clause if it tries to do it twice.

                $transitions.onError({}, function (transition) {
                    if (
                        (transition.error().detail && transition.error().detail.redirectComing) ||
                        handlingStateChangeError ||
                        (transition.error().type !== 4 && transition.error().type !== 6)
                    ) {
                        return;
                    }
                    stateCounts.errors++;
                    handlingStateChangeError = true;

                    var destination =
                        (transition.to() && (transition.to().title || transition.to().name || transition.to().loadedTemplateUrl)) ||
                        'unknown target';

                    var msg =
                        'Error routing to' +
                        destination +
                        '. ' +
                        (transition.error().data || '') +
                        '.<br/>' +
                        (transition.error().statusText || '') +
                        ': ' +
                        (transition.error().status || '');

                    $log.warn(msg, [transition.to()]);
                    $location.path('/');
                });
            }

            function init () {
                handleRoutingErrors();
            }

            function getStates () {
                return $state.get();
            }
        }
    }
})();
